import { Group } from "@qw/ui";
import type { FC } from "react";

import { useChat } from "../../providers";
import { ChatFormFileDropzone } from "./chat-form-file-dropzone";
import { ChatFormFilesList } from "./chat-form-files-list";
import { ChatFormFooter } from "./chat-form-footer";
import { ChatFormProvider } from "./chat-form-provider";
import { ChatFormTextInputWithSlashCommands } from "./chat-form-text-input-with-slash-commands";

export const ChatForm: FC = () => {
  const { chatSession } = useChat();

  // Key forces remount on session change, ensuring form state resets and localStorage loads for the new session
  return (
    <ChatFormProvider key={chatSession.id}>
      <ChatFormFileDropzone>
        <Group
          type="flex"
          className="rounded-md gap-1.5 border border-input bg-card text-sm ring-offset-background focus-within:outline-hidden focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2"
        >
          <ChatFormFilesList />
          <ChatFormTextInputWithSlashCommands />
          <ChatFormFooter />
        </Group>
      </ChatFormFileDropzone>
    </ChatFormProvider>
  );
};
